import {
  SponsoredBrandsAction,
  SponsoredBrandsActionType,
  SponsoredBrandsState,
  SponsoredBrandsTargetForTableState,
  SponsoredBrandsTargetState,
} from "../types/sponsoredBrands"

const initialState: SponsoredBrandsState = {
  campaignData: {
    campaignsResult: [],
    currentPageNo: 0,
    defaultBid: 0,
    defaultOrder: 0,
    defaultTargetAcos: [],
    getAOVData: null,
    lastDateWithoutData: "",
    limitValue: 0,
    limitedCPCValue: null,
    maxTargetCPC: 0,
    minTargetCPC: 0,
    totalPages: 0,
    totalRecords: 0,
  },
  loading: false,
  error: null,
}

export const sponsoredBrandsReducer = (
  state = initialState,
  action: SponsoredBrandsAction
): SponsoredBrandsState => {
  switch (action.type) {
    case SponsoredBrandsActionType.FETCH_SPONSORED_BRANDS_CAMPAIGNS:
      return {
        ...state,
        loading: true,
        error: null,
      }
    case SponsoredBrandsActionType.FETCH_SPONSORED_BRANDS_CAMPAIGNS_SUCCESS:
      return {
        campaignData: action.payload,
        loading: false,
        error: null,
      }
    case SponsoredBrandsActionType.FETCH_SPONSORED_BRANDS_CAMPAIGNS_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      }
    default:
      return state
  }
}

const initialTargetState: SponsoredBrandsTargetState = {
  targetData: [],
  loading: false,
  error: null,
}

export const sponsoredBrandsTargetReducer = (
  state = initialTargetState,
  action: SponsoredBrandsAction
): SponsoredBrandsTargetState => {
  switch (action.type) {
    case SponsoredBrandsActionType.FETCH_SPONSORED_BRANDS_TARGETS:
      return {
        ...state,
        loading: true,
        error: null,
      }
    case SponsoredBrandsActionType.FETCH_SPONSORED_BRANDS_TARGETS_SUCCESS: {
      const incomingCampaignIds = new Set(action.payload.map((target) => target.campaignId))
      return {
        targetData: [
          ...state.targetData.filter((target) => !incomingCampaignIds.has(target.campaignId)),
          ...action.payload,
        ],
        loading: false,
        error: null,
      }
    }
    case SponsoredBrandsActionType.RESET_SPONSORED_BRANDS_TARGETS:
      return initialTargetState

    case SponsoredBrandsActionType.FETCH_SPONSORED_BRANDS_TARGETS_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      }
    default:
      return state
  }
}

const initialTargetForTableState: SponsoredBrandsTargetForTableState = {
  targetDataForTable: [],
}

export const sponsoredBrandsTargetForTableReducer = (
  state = initialTargetForTableState,
  action: SponsoredBrandsAction
): SponsoredBrandsTargetForTableState => {
  switch (action.type) {
    case SponsoredBrandsActionType.ADD_SPONSORED_BRANDS_TARGETS: {
      const incomingCampaignIds = new Set(action.payload.map((target) => target.campaignId))
      return {
        targetDataForTable: [
          ...state.targetDataForTable.filter(
            (target) => !incomingCampaignIds.has(target.campaignId)
          ),
          ...action.payload,
        ],
      }
    }
    case SponsoredBrandsActionType.UPDATE_SPONSORED_BRANDS_TARGETS_LOCAL:
      return {
        targetDataForTable: state.targetDataForTable.map((target) => {
          const findedTargetData = action.payload.find(
            (updatedTarget) => updatedTarget.campaignId === target.campaignId
          )
          return findedTargetData || target
        }),
      }
    case SponsoredBrandsActionType.RESET_SPONSORED_BRANDS_TARGETS:
      return initialTargetForTableState

    default:
      return state
  }
}
